const IncidentDetailsStyles = {
  container: { p: 3 },
  card: (selected: boolean) => ({
    cursor: "pointer",
    border: selected ? "2px solid #1976d2" : "1px solid #e0e0e0",
    "&:hover": { borderColor: "#1976d2" },
  }),
  cardContent: { textAlign: "center", p: 2 },
  iconBox: { display: "flex", alignItems: "center", gap: 1 },
  icon: { fontSize: 40 },
  title: { fontFamily: "var(--font-noto-sans)" },
  subtitle: { mt: 1, minHeight: 48, },
  vehicleTitle: { fontFamily: "var(--font-noto-sans)", mt: 2 },
  injuryTitle: { mt: 2 },
  uploadBox: { mt: 2 },
  uploadInput: { display: "none" },
  uploadButton: { fontFamily: "var(--font-noto-sans)" },
  uploadCaption: { ml: 2, fontFamily: "var(--font-noto-sans)" },
  errorText: { display: "block", mt: 1, fontFamily: "var(--font-noto-sans)" },
  uploadedPhotosBox: { mt: 2 },
  uploadedPhotosText: { fontFamily: "var(--font-noto-sans)" },
  uploadedPhotosList: { display: "flex", flexWrap: "wrap", gap: 1, mt: 1 },
  uploadedPhotoBox: { position: "relative" },
  uploadedPhotoImg: {
    width: 100,
    height: 100,
    objectFit: "cover" as React.CSSProperties["objectFit"],
  },
  witnessSection: { display: "flex", alignItems: "center", gap: 1 },
};

export default IncidentDetailsStyles;
